import React from 'react'
import PropTypes from 'prop-types'
import colors from '@settings/styleSettings'

const styles = {
  line: {
    borderTopWidth: 1,
    width: '100%',
    borderTopStyle: 'solid',
  },
}

export const Line = ({ lineColor, style }) => (
  <div style={{ ...styles.line, borderColor: lineColor, ...style }} />
)

Line.propTypes = {
  lineColor: PropTypes.string,
  style: PropTypes.shape({}),
}

Line.defaultProps = {
  lineColor: colors.softGray,
  style: null,
}
